import { createSlice } from "@reduxjs/toolkit";

interface OrdersStateType {
    OrdersError?: string | object | null | undefined | unknown,
    message: any,
    loading: any,
    orders?: any
}
export const initialState: OrdersStateType = {
    OrdersError: null,
    message: null,
    loading: false,
    orders: null,
};

const OrdersSlice = createSlice({
    name: "orders",
    initialState,
    reducers: {
        setOrdersSuccessful(state, action) {
            state.orders = action.payload
        },
        setOrdersFailed(state, action) {
            state.orders = action.payload
        },
        clearOrders(state) {
            state.orders = null; // Reset `agency` state
        },
    },
});

export const {
    setOrdersSuccessful,
    setOrdersFailed,
    clearOrders 
} = OrdersSlice.actions

export default OrdersSlice.reducer;